import * as Factory from 'factory.ts'
import faker from 'faker'

import { PayCardAddressMock } from './payCard.factory'
import { type PayCardholder } from '../../models/PayCardholder'

export const PayCardholderMock = Factory.Sync.makeFactory<PayCardholder>({
  id: Factory.each(() => faker.random.number()),
  user_id: Factory.each(() => faker.random.number()),
  email: Factory.each(() => faker.internet.email()),
  department_id: faker.random.number(),
  profile_image: null,
  first_name: Factory.each(() => faker.name.firstName()),
  last_name: Factory.each(() => faker.name.lastName()),
  billing_address: Factory.each(() => PayCardAddressMock.build()),
  external_id: `ich_${faker.random.alphaNumeric(24)}`,
  tos_accepted: true,
})
